var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSpid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hi-Fi",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 69.098,
    viewBox: "0 0 139 69.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPID-1280-home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero-block-home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-198",
    d: "M28.542,28.238a116.572,116.572,0,0,0-12.862-1.2q-3.671,0-4.746.677A2.352,2.352,0,0,0,9.86,29.857a2.04,2.04,0,0,0,1.446,2.032,55.742,55.742,0,0,0,7.413,1.656q5.967,1.092,8.489,3.575t2.521,8.055q0,12.2-14.9,12.195A63.78,63.78,0,0,1,2.965,56.015L.593,55.563l.3-8.43a116.258,116.258,0,0,0,12.788,1.2,11.347,11.347,0,0,0,4.893-.714,2.311,2.311,0,0,0,1.3-2.146A2.22,2.22,0,0,0,18.5,43.369a34.956,34.956,0,0,0-7.117-1.657Q5.634,40.736,2.817,38.4T0,30.082Q0,24.1,4,21.049A16.528,16.528,0,0,1,14.308,18a68.307,68.307,0,0,1,11.935,1.431l2.447.451Z",
    transform: "translate(0 -3.538)",
    fill: "#06c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-200",
    d: "M46,72.636V18.908H56.108v2.044Q61.048,18,64.773,18q7.675,0,11.324,4.579t3.649,15.55q0,10.974-4.029,15.248T62.492,57.652a34.856,34.856,0,0,1-5.4-.454l-.912-.152v15.59ZM62.8,27.081a15.513,15.513,0,0,0-5.7,1.135l-.912.378V48.421a44.126,44.126,0,0,0,5.548.454q4.407,0,6.043-2.573t1.634-8.778q0-10.442-6.613-10.443Z",
    transform: "translate(-9.04 -3.538)",
    fill: "#06c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-202",
    d: "M164.746,0V52.924h-10V51.337a21.937,21.937,0,0,1-9.093,2.5q-8.194,0-11.424-4.763T131,33.985q0-10.32,3.871-15.046t11.687-4.725a41.244,41.244,0,0,1,6.689.756l1.428.3V0ZM153.622,43.852l1.053-.226V23.741a41.461,41.461,0,0,0-7.366-.756q-6.087,0-6.087,10.887,0,5.9,1.352,8.392a4.69,4.69,0,0,0,4.472,2.5,25.9,25.9,0,0,0,6.576-.908Z",
    transform: "translate(-25.746)",
    fill: "#06c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-204",
    d: "M107.545,40.694a9.979,9.979,0,0,1-7.571-3.134A10.836,10.836,0,0,1,97,29.789a10.7,10.7,0,0,1,2.956-7.714A10.037,10.037,0,0,1,107.522,19a9.662,9.662,0,0,1,7.484,3.149,11.1,11.1,0,0,1,2.883,7.774,10.819,10.819,0,0,1-2.883,7.7,9.751,9.751,0,0,1-7.462,3.074",
    transform: "translate(-19.064 -3.734)",
    fill: "#06c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-206",
    d: "M97,63.111a11.2,11.2,0,0,1,2.956-7.945A9.893,9.893,0,0,1,107.522,52a9.532,9.532,0,0,1,7.485,3.241,11.636,11.636,0,0,1,2.883,8.008",
    transform: "translate(-19.064 -10.22)",
    fill: "#06c",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpid);
export default __webpack_public_path__ + "static/media/logo-spid.0e58c092feee8f07bb9eadefcb0d2373.svg";
export { ForwardRef as ReactComponent };